import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Online Fee Payment</h1>
                <p>Home &gt; Online Fee Payment</p>
            </div>
        </div>
    )
}

export default Hero;